import React, { useState, useEffect, useRef } from "react";
import { callCrashGameGraphQLQuery } from "../../hooks/crashHooksdummy/axiosClient";
import useWeb3 from "../../hooks/useWeb3";
import Web3 from "web3";
import { Log } from "ethers";
import "./crash.scss";
import { formatSmartDecimal } from "../../utils/helpers";
import useCrashDataFetcher from "../../hooks/dataFetcher/useCrashDataFetcher";
import { useTranslation } from "react-i18next";
import { getIsGameActivePlayers } from "../../utils/services";

const Players = ({ winningsHistory, gameState, setWinningsHistory }) => {
  const { t } = useTranslation();
  const { getCrashGameIndex } = useCrashDataFetcher();

  const web3 = useWeb3();
  useEffect(() => {
    if (gameState === 'running' && winningsHistory?.length == 0) {
      oldHistoryBetData()
    }
  }, [gameState])
  const oldHistoryBetData = async () => {
    try {
      const index = await getCrashGameIndex();
      const apiCallActivePlayers = await getIsGameActivePlayers(index - 1)
      setWinningsHistory(apiCallActivePlayers);
    }
    catch (err) {
    }
  }


  const totalPayout = winningsHistory?.reduce((acc, bet) => {
    const payoutInEther = parseFloat(
      web3.utils.fromWei(String(bet.amount), "mwei")
    );
    return acc + payoutInEther;
  }, 0);
  function shortenAddress(address, chars = 4) {
    if (!address) return "";
    return `${address.slice(0, 2 + chars)}...${address.slice(-chars)}`;
  }
  return (
    <>
      <div className="rightbottom">
        <h4 className="heading-text">{t('Activity')}</h4>
        <div className="bottomhead">
          <div className="text">
            <p>{t('Active Positions')}</p>
            <h6>{winningsHistory?.length > 0 ? winningsHistory?.length : '0'}</h6>
          </div>
          <div className="text">
            <p>{t('Market Depth')}</p>
            <h6>{totalPayout ? `$${formatSmartDecimal(totalPayout)}` : '$0'}</h6>
          </div>
        </div>
        <div className="bettingdetails">
          <div className="mainbet">
            <p className="firstpara">{t('Participant')}</p>
            {/* <p>Termination Percentage</p> */}
            <p>{t('Amount')}</p>
          </div>
          <div className="innerdetail">
            {winningsHistory &&
              winningsHistory?.length > 0 ?
              winningsHistory?.map((bet) => (
                <div className="innerbet" key={bet?.id}>
                  <p className="firsthead"> <img src={bet?.user?.profilePic ? bet?.user?.profilePic : "/assets/userprofile.svg"} alt="img" className="img-fluid" /> {bet?.user?.name ? bet?.user?.name : shortenAddress(bet?.walletAddress)}
                  </p>
                  {/* <p>
                    --
                  </p> */}
                  <p>
                    $
                    {(() => {
                      const betAmountInEther =
                        bet?.amount ?
                          parseFloat(
                            Web3?.utils?.fromWei(String(bet?.amount), "mwei")
                          )
                          : "0.00";
                      return formatSmartDecimal(betAmountInEther);
                    })()}{" "}
                  </p>
                </div>
              ))
              :
              <>
                <div className="connectwalletmain w-100">
                  <div className="mainimg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                      <path d="M3.5 3.5L38.5 38.5" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M14.6124 4.70799C17.781 3.47043 21.2416 3.18318 24.5709 3.88137C27.9001 4.57956 30.9538 6.23292 33.3582 8.6392C35.7626 11.0455 37.4136 14.1004 38.1092 17.4302C38.8049 20.76 38.5149 24.2204 37.2749 27.388" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M33.3901 33.3899C31.7631 35.0169 29.8314 36.3076 27.7056 37.1882C25.5797 38.0687 23.3012 38.522 21.0001 38.522C18.6991 38.522 16.4206 38.0687 14.2947 37.1882C12.1688 36.3076 10.2372 35.0169 8.61013 33.3899C6.98306 31.7628 5.69239 29.8312 4.81182 27.7053C3.93125 25.5794 3.47803 23.3009 3.47803 20.9999C3.47803 18.6988 3.93125 16.4203 4.81182 14.2944C5.69239 12.1686 6.98306 10.2369 8.61013 8.60986" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h6 className="connecthead">
                    {t('No participants yet')}.
                  </h6>
                </div></>
            }
          </div>

        </div>
      </div>
    </>
  );
};

export default Players;